import { createApiRef } from '@backstage/core-plugin-api';
import type { ChatRequest, AgentResponse, AgentInfo } from './types';

/**
 * API for communicating with the Golden Path AI Agent
 */
export interface AiAgentApi {
  /**
   * Send a chat message to the agent
   */
  sendMessage(request: ChatRequest): Promise<AgentResponse>;

  /**
   * Get agent information and capabilities
   */
  getAgentInfo(): Promise<AgentInfo[]>;

  /**
   * Check agent health
   */
  healthCheck(): Promise<{ status: string; agent: string; version: string }>;
}

export const aiAgentApiRef = createApiRef<AiAgentApi>({
  id: 'plugin.ai-agent-chat.service',
});
